module.exports = new __parcel__URL__("Retro.f40bdbc6.svg").toString();